<template>
  <div v-if="loading" class="text-center py-4">
    <div class="spinner-border text-purple spinner-border-sm" role="status"></div>
  </div>
  <apexchart
    v-else
    type="polarArea"
    width="100%"
    :options="chartOptions"
    :series="series"
  />
</template>

<script>
import api from '../../services/api';

export default {
  name: 'TopSellingProductsChart',
  data() {
    return {
      loading: true,
      series: [],
      labels: [],
    };
  },
  computed: {
    chartOptions() {
      return {
        chart: { width: '100%', type: 'polarArea', offsetX: 0, offsetY: 0 },
        stroke: { width: 0 },
        yaxis: { show: false },
        fill: { opacity: 1 },
        colors: ['#B142E1', '#EA5BE6', '#7A2CB2', '#7E32C4', '#FC7483'],
        labels: this.labels,
        legend: {
          show: true, position: 'bottom', horizontalAlign: 'center',
          fontSize: '14px', fontWeight: 500,
          labels: { colors: '#838A95' },
          markers: { width: 16, height: 16, radius: 2 },
        },
        plotOptions: {
          polarArea: { rings: { strokeWidth: 0 }, spokes: { strokeWidth: 0 } },
        },
      };
    },
  },
  async mounted() {
    try {
      const res = await api.get('/dashboard');
      const top = res.data.data.topProductos || [];
      this.series = top.map(p => p.unidades);
      this.labels = top.map(p => p.producto.length > 25 ? p.producto.slice(0, 25) + '…' : p.producto);
    } catch (e) {
      console.error('TopProductos', e);
    } finally {
      this.loading = false;
    }
  },
};
</script>
